@if (step.order === 1) {
	<div class="d-flex justify-content-end my-4">
		<button
			class="ms-3"
			type="button"
			itButton="primary"
			(click)="proponents = []; createAmendment.toggle()"
		>
			{{ "iterlex.create-amendment" | translate }}
		</button>
		@if (nextStep) {
			<button
				class="ms-3"
				type="button"
				itButton="secondary"
				(click)="moveLastVersionsToStep(nextStep.id)"
			>
				{{ "it.core.go-to" | translate }}
				{{ nextStep.label["iterlex.currentLanguage" | translate] }}
			</button>
		}
	</div>
	<it-table itSort>
		<ng-container thead>
			<tr>
				<th it-sort-header="" scope="col">
					{{ "iterlex.title" | translate }}
				</th>
				<th it-sort-header="" scope="col">
					{{ "iterlex.date" | translate }}
				</th>
				<th scope="col">{{ "iterlex.versions" | translate }}</th>
				<th scope="col">{{ "iterlex.actions" | translate }}</th>
			</tr>
		</ng-container>
		<ng-container tbody>
			@for (document of documentsComplete; track document.workUri) {
				<tr>
					<th>
						{{ document.title
						}}<button
							type="button"
							itButton="link"
							(click)="
								currentDocument = document;
								editDocumentModal.toggle()
							"
						>
							<it-icon
								name="pencil"
								[title]="'it.general.edit' | translate"
							></it-icon></button
						><br />{{ "iterlex.number" | translate }}
						{{ document.number }}
					</th>
					<td>{{ document.date | date: "d/M/yyyy" }}</td>
					<td>
						@for (
							version of document.versions;
							track version.expressionUri
						) {
							@if (!version.metadata.parent) {
								<it-accordion
									[title]="
										('iterlex.article' | translate) +
										' ' +
										(version.metadata.article ?? '?') +
										' - ' +
										(
											version.metadata.proponents ?? []
										).join(', ') +
										' - ' +
										(version.metadata.amendmentType
											? ('iterlex.amendment-' +
													version.metadata
														.amendmentType
												| translate)
											: '?') +
										' - ' +
										((version.date
											| date: 'd/M/yyyy HH:mm') ??
											version.date) +
										' ' +
										(version.language | uppercase)
									"
								>
									<app-files
										[authority]="authority"
										[body]="body"
										[dossier]="dossier"
										[documentComplete]="document"
										[version]="version"
										[phase]="phase"
										[step]="step"
										(updateFileList)="
											getDocumentComplete(
												document.workUri
											)
										"
									/>
									<div class="text-end mt-4">
										<button
											type="button"
											itButton="outline-primary"
											[disabled]="
												progressDeleteVersionUri ===
												version.expressionUri
											"
											size="xs"
											class="me-2"
											(click)="
												currentDocument = document;
												currentVersion = version;
												createSubamenment = true;
												proponents = [];
												createVersionModal.toggle()
											"
										>
											{{
												"iterlex.create-subamendment"
													| translate
											}}
										</button>
										<button
											type="button"
											itButton="outline-primary"
											[disabled]="
												progressDeleteVersionUri ===
												version.expressionUri
											"
											size="xs"
											class="me-2"
											(click)="
												currentVersion = version;
												proponents = getProponents(
													version.metadata.proponents
												);
												editMetadataModal.toggle()
											"
										>
											{{
												"iterlex.edit-amendment"
													| translate
											}}
										</button>
										<button
											type="button"
											itButton="outline-primary"
											[disabled]="
												progressDeleteVersionUri ===
												version.expressionUri
											"
											size="xs"
											class="me-2"
											(click)="
												getPhasesAndSteps();
												getVersionSteps(
													version.expressionUri
												);
												currentVersion = version;
												moveVersionModal.toggle()
											"
										>
											{{
												"iterlex.select-steps"
													| translate
											}}
										</button>
										<button
											type="button"
											itButton="outline-danger"
											[disabled]="
												progressDeleteVersionUri ===
												version.expressionUri
											"
											[progress]="
												progressDeleteVersionUri ===
												version.expressionUri
											"
											size="xs"
											(click)="
												currentDocument = document;
												currentVersion = version;
												deleteVersionModal.toggle()
											"
										>
											{{
												"iterlex.delete-version"
													| translate
											}}
										</button>
									</div>
									@for (
										subversion of document.versions;
										track subversion.expressionUri
									) {
										@if (
											subversion.metadata.parent ===
											version.expressionUri
										) {
											<it-accordion
												[title]="
													('iterlex.article'
														| translate) +
													' ' +
													(subversion.metadata
														.article ?? '?') +
													' - ' +
													(
														subversion.metadata
															.proponents ?? []
													).join(', ') +
													' - ' +
													(subversion.metadata
														.amendmentType
														? ('iterlex.amendment-' +
																subversion
																	.metadata
																	.amendmentType
															| translate)
														: '?') +
													' - ' +
													((subversion.date
														| date
															: 'd/M/yyyy HH:mm') ??
														subversion.date) +
													' ' +
													(subversion.language
														| uppercase)
												"
											>
												<app-files
													[authority]="authority"
													[body]="body"
													[dossier]="dossier"
													[documentComplete]="
														document
													"
													[version]="subversion"
													[phase]="phase"
													[step]="step"
													(updateFileList)="
														getDocumentComplete(
															document.workUri
														)
													"
												/>
												<div class="text-end mt-4">
													<button
														type="button"
														itButton="outline-primary"
														[disabled]="
															progressDeleteVersionUri ===
															subversion.expressionUri
														"
														size="xs"
														class="me-2"
														(click)="
															currentVersion =
																subversion;
															proponents =
																getProponents(
																	subversion
																		.metadata
																		.proponents
																);
															editMetadataModal.toggle()
														"
													>
														{{
															"iterlex.edit-amendment"
																| translate
														}}
													</button>
													<button
														type="button"
														itButton="outline-primary"
														[disabled]="
															progressDeleteVersionUri ===
															subversion.expressionUri
														"
														size="xs"
														class="me-2"
														(click)="
															getPhasesAndSteps();
															getVersionSteps(
																subversion.expressionUri
															);
															currentVersion =
																subversion;
															moveVersionModal.toggle()
														"
													>
														{{
															"iterlex.select-steps"
																| translate
														}}
													</button>
													<button
														type="button"
														itButton="outline-danger"
														[disabled]="
															progressDeleteVersionUri ===
															subversion.expressionUri
														"
														[progress]="
															progressDeleteVersionUri ===
															subversion.expressionUri
														"
														size="xs"
														(click)="
															currentDocument =
																document;
															currentVersion =
																subversion;
															deleteVersionModal.toggle()
														"
													>
														{{
															"iterlex.delete-version"
																| translate
														}}
													</button>
												</div>
											</it-accordion>
										}
									}
								</it-accordion>
							}
						}
						@for (
							attachment of attachments[document.workUri];
							track attachment.workUri
						) {
							<div class="p-2">
								<app-document
									[currentPhase]="phase"
									[currentStep]="step"
									[authority]="authority"
									[body]="body"
									[documentTypes]="documentTypes"
									[dossier]="dossier"
									[document]="attachment"
									(setCurrentPhaseEvent)="
										setCurrentPhaseEvent.emit($event)
									"
									(deleteDocument)="
										currentDocument = attachment;
										deleteDocumentModal.toggle()
									"
									(refreshDocuments)="this.getDocuments()"
								/>
							</div>
						}
					</td>
					<td class="text-end">
						<button
							type="button"
							itButton="primary"
							[disabled]="
								progressDeleteDocumentUri === document.workUri
							"
							size="xs"
							(click)="
								currentDocument = document;
								currentVersion = document.versions.at(-1);
								createSubamenment = false;
								proponents = getProponents(
									document.versions.at(-1)?.metadata
										?.proponents
								);
								createVersionModal.toggle()
							"
						>
							{{ "iterlex.create-version" | translate }}
						</button>
						<button
							type="button"
							itButton="primary"
							[disabled]="
								progressDeleteDocumentUri === document.workUri
							"
							size="xs"
							(click)="
								currentDocument = document;
								createAttachmentModal.toggle()
							"
							class="ms-3"
						>
							{{ "iterlex.create-attachment" | translate }}
						</button>
						<button
							type="button"
							itButton="outline-danger"
							[disabled]="
								progressDeleteDocumentUri === document.workUri
							"
							[progress]="
								progressDeleteDocumentUri === document.workUri
							"
							size="xs"
							(click)="
								currentDocument = document;
								deleteDocumentModal.toggle()
							"
							class="ms-3"
						>
							{{ "iterlex.delete-document" | translate }}
						</button>
					</td>
				</tr>
			}
		</ng-container>
	</it-table>
} @else if (step.order === 2) {
	<div class="d-flex justify-content-end my-4">
		<button
			class="ms-3"
			type="button"
			itButton="secondary"
			(click)="save()"
		>
			{{ "it.general.save" | translate }}
		</button>
		<button
			class="ms-3"
			type="button"
			itButton="secondary"
			(click)="sortAmendmentsAutomatically()"
		>
			{{ "iterlex.sort-amendments" | translate }}
		</button>
		@if (nextStep) {
			<button
				class="ms-3"
				type="button"
				itButton="secondary"
				(click)="moveLastVersionsToStep(nextStep.id)"
			>
				{{ "it.core.go-to" | translate }}
				{{ nextStep.label["iterlex.currentLanguage" | translate] }}
			</button>
		}
	</div>
	<it-table itSort>
		<ng-container thead>
			<tr>
				<th scope="col"></th>
				<th it-sort-header="" scope="col">
					{{ "iterlex.title" | translate }}
				</th>
				<th it-sort-header="" scope="col">
					{{ "iterlex.date" | translate }}
				</th>
				<th scope="col"></th>
				<th scope="col">{{ "iterlex.notes" | translate }}</th>
			</tr>
		</ng-container>
		<ng-container tbody>
			@for (document of documentsComplete; track document.workUri) {
				@if (document.versions[0]) {
					<tr>
						<td>
							<button
								type="button"
								itButton="outline-primary"
								size="xs"
								class="me-2"
								[disabled]="$last"
								(click)="orderAmendment($index, 1)"
							>
								<it-icon name="arrow-down"></it-icon>
							</button>
							<button
								type="button"
								itButton="outline-primary"
								size="xs"
								[disabled]="$first"
								(click)="orderAmendment($index, -1)"
							>
								<it-icon name="arrow-up"></it-icon>
							</button>
						</td>
						<th>
							{{ document.title
							}}<button
								type="button"
								itButton="link"
								(click)="
									currentDocument = document;
									editDocumentModal.toggle()
								"
							>
								<it-icon
									name="pencil"
									[title]="'it.general.edit' | translate"
								></it-icon></button
							><br />{{ "iterlex.number" | translate }}
							{{ document.number }}
						</th>
						<td>{{ document.date | date: "d/M/yyyy" }}</td>
						<td>
							@for (
								version of document.versions;
								track version.expressionUri
							) {
								@if (!version.metadata.parent) {
									<it-accordion
										[title]="
											('iterlex.article' | translate) +
											' ' +
											(version.metadata.article ?? '?') +
											' - ' +
											(
												version.metadata.proponents ??
												[]
											).join(', ') +
											' - ' +
											(version.metadata.amendmentType
												? ('iterlex.amendment-' +
														version.metadata
															.amendmentType
													| translate)
												: '?') +
											' - ' +
											((version.date
												| date: 'd/M/yyyy HH:mm') ??
												version.date) +
											' ' +
											(version.language | uppercase)
										"
									>
										<app-files
											[authority]="authority"
											[body]="body"
											[dossier]="dossier"
											[documentComplete]="document"
											[version]="version"
											[phase]="phase"
											[step]="step"
											(updateFileList)="
												getDocumentComplete(
													document.workUri
												)
											"
										/>
										<div class="text-end mt-4">
											<button
												type="button"
												itButton="outline-primary"
												size="xs"
												class="me-2"
												(click)="
													getPhasesAndSteps();
													getVersionSteps(
														version.expressionUri
													);
													currentVersion = version;
													moveVersionModal.toggle()
												"
											>
												{{
													"iterlex.select-steps"
														| translate
												}}
											</button>
											<button
												type="button"
												itButton="outline-danger"
												size="xs"
												(click)="
													currentDocument = document;
													currentVersion = version;
													deleteVersionModal.toggle()
												"
											>
												{{
													"iterlex.delete-version"
														| translate
												}}
											</button>
										</div>
										@for (
											subversion of document.versions;
											track subversion.expressionUri
										) {
											@if (
												subversion.metadata.parent ===
												version.expressionUri
											) {
												<it-accordion
													[title]="
														('iterlex.article'
															| translate) +
														' ' +
														(subversion.metadata
															.article ?? '?') +
														' - ' +
														(
															subversion.metadata
																.proponents ??
															[]
														).join(', ') +
														' - ' +
														(subversion.metadata
															.amendmentType
															? ('iterlex.amendment-' +
																	subversion
																		.metadata
																		.amendmentType
																| translate)
															: '?') +
														' - ' +
														((subversion.date
															| date
																: 'd/M/yyyy HH:mm') ??
															subversion.date) +
														' ' +
														(subversion.language
															| uppercase)
													"
												>
													<app-files
														[authority]="authority"
														[body]="body"
														[dossier]="dossier"
														[documentComplete]="
															document
														"
														[version]="subversion"
														[phase]="phase"
														[step]="step"
														(updateFileList)="
															getDocumentComplete(
																document.workUri
															)
														"
													/>
													<div class="text-end mt-4">
														<button
															type="button"
															itButton="outline-primary"
															[disabled]="
																progressDeleteVersionUri ===
																subversion.expressionUri
															"
															size="xs"
															class="me-2"
															(click)="
																getPhasesAndSteps();
																getVersionSteps(
																	subversion.expressionUri
																);
																currentVersion =
																	subversion;
																moveVersionModal.toggle()
															"
														>
															{{
																"iterlex.select-steps"
																	| translate
															}}
														</button>
														<button
															type="button"
															itButton="outline-danger"
															[disabled]="
																progressDeleteVersionUri ===
																subversion.expressionUri
															"
															[progress]="
																progressDeleteVersionUri ===
																subversion.expressionUri
															"
															size="xs"
															(click)="
																currentDocument =
																	document;
																currentVersion =
																	subversion;
																deleteVersionModal.toggle()
															"
														>
															{{
																"iterlex.delete-version"
																	| translate
															}}
														</button>
													</div>
												</it-accordion>
											}
										}
									</it-accordion>
								}
							}
						</td>
						<td>
							<it-input
								[(ngModel)]="
									document.versions[0].metadata.orderNotes
								"
								type="text"
							></it-input>
						</td>
					</tr>
				}
			}
		</ng-container>
	</it-table>
} @else if (step.order === 3) {
	<div class="d-flex justify-content-end my-4">
		<button
			class="ms-3"
			type="button"
			itButton="secondary"
			(click)="save()"
		>
			{{ "it.general.save" | translate }}
		</button>
	</div>
	<it-table itSort>
		<ng-container thead>
			<tr>
				<th it-sort-header="" scope="col">
					{{ "iterlex.title" | translate }}
				</th>
				<th it-sort-header="" scope="col">
					{{ "iterlex.date" | translate }}
				</th>
				<th scope="col"></th>
				<th scope="col">{{ "iterlex.yes" | translate }}</th>
				<th scope="col">{{ "iterlex.no" | translate }}</th>
				<th scope="col">{{ "iterlex.abstensions" | translate }}</th>
				<th scope="col">{{ "iterlex.notes" | translate }}</th>
			</tr>
		</ng-container>
		<ng-container tbody>
			@for (document of documentsComplete; track document.workUri) {
				@if (document.versions[0]) {
					<tr>
						<th>
							{{ document.title
							}}<button
								type="button"
								itButton="link"
								(click)="
									currentDocument = document;
									editDocumentModal.toggle()
								"
							>
								<it-icon
									name="pencil"
									[title]="'it.general.edit' | translate"
								></it-icon></button
							><br />{{ "iterlex.number" | translate }}
							{{ document.number }}
						</th>
						<td>{{ document.date | date: "d/M/yyyy" }}</td>
						<td>
							@for (
								version of document.versions;
								track version.expressionUri
							) {
								@if (!version.metadata.parent) {
									<it-accordion
										[title]="
											('iterlex.article' | translate) +
											' ' +
											(version.metadata.article ?? '?') +
											' - ' +
											(
												version.metadata.proponents ??
												[]
											).join(', ') +
											' - ' +
											(version.metadata.amendmentType
												? ('iterlex.amendment-' +
														version.metadata
															.amendmentType
													| translate)
												: '?') +
											' - ' +
											((version.date
												| date: 'd/M/yyyy HH:mm') ??
												version.date) +
											' ' +
											(version.language | uppercase)
										"
									>
										<app-files
											[authority]="authority"
											[body]="body"
											[dossier]="dossier"
											[documentComplete]="document"
											[version]="version"
											[phase]="phase"
											[step]="step"
											(updateFileList)="
												getDocumentComplete(
													document.workUri
												)
											"
										/>
										<button
											type="button"
											itButton="outline-primary"
											size="xs"
											(click)="
												getPhasesAndSteps();
												getVersionSteps(
													version.expressionUri
												);
												currentVersion = version;
												moveVersionModal.toggle()
											"
										>
											{{
												"iterlex.select-steps"
													| translate
											}}
										</button>
										<button
											type="button"
											itButton="outline-danger"
											size="xs"
											(click)="
												currentDocument = document;
												currentVersion = version;
												deleteVersionModal.toggle()
											"
										>
											{{
												"iterlex.delete-version"
													| translate
											}}
										</button>
										@for (
											subversion of document.versions;
											track subversion.expressionUri
										) {
											@if (
												subversion.metadata.parent ===
												version.expressionUri
											) {
												<it-accordion
													[title]="
														('iterlex.article'
															| translate) +
														' ' +
														(subversion.metadata
															.article ?? '?') +
														' - ' +
														(
															subversion.metadata
																.proponents ??
															[]
														).join(', ') +
														' - ' +
														(subversion.metadata
															.amendmentType
															? ('iterlex.amendment-' +
																	subversion
																		.metadata
																		.amendmentType
																| translate)
															: '?') +
														' - ' +
														((subversion.date
															| date
																: 'd/M/yyyy HH:mm') ??
															subversion.date) +
														' ' +
														(subversion.language
															| uppercase)
													"
												>
													<app-files
														[authority]="authority"
														[body]="body"
														[dossier]="dossier"
														[documentComplete]="
															document
														"
														[version]="subversion"
														[phase]="phase"
														[step]="step"
														(updateFileList)="
															getDocumentComplete(
																document.workUri
															)
														"
													/>
													<div class="d-flex">
														<it-input
															[(ngModel)]="
																subversion
																	.metadata
																	.yes
															"
															type="number"
															[label]="
																'iterlex.yes'
																	| translate
															"
														></it-input>
														<it-input
															[(ngModel)]="
																subversion
																	.metadata.no
															"
															type="number"
															[label]="
																'iterlex.no'
																	| translate
															"
														></it-input>
														<it-input
															[(ngModel)]="
																subversion
																	.metadata
																	.abs
															"
															type="number"
															[label]="
																'iterlex.abstensions'
																	| translate
															"
														></it-input>
													</div>
													<div class="text-end mt-4">
														<button
															type="button"
															itButton="outline-primary"
															[disabled]="
																progressDeleteVersionUri ===
																subversion.expressionUri
															"
															size="xs"
															class="me-2"
															(click)="
																getPhasesAndSteps();
																getVersionSteps(
																	subversion.expressionUri
																);
																currentVersion =
																	subversion;
																moveVersionModal.toggle()
															"
														>
															{{
																"iterlex.select-steps"
																	| translate
															}}
														</button>
														<button
															type="button"
															itButton="outline-danger"
															[disabled]="
																progressDeleteVersionUri ===
																subversion.expressionUri
															"
															[progress]="
																progressDeleteVersionUri ===
																subversion.expressionUri
															"
															size="xs"
															(click)="
																currentDocument =
																	document;
																currentVersion =
																	subversion;
																deleteVersionModal.toggle()
															"
														>
															{{
																"iterlex.delete-version"
																	| translate
															}}
														</button>
													</div>
												</it-accordion>
											}
										}
									</it-accordion>
								}
							}
						</td>
						<td>
							<it-input
								[(ngModel)]="document.versions[0].metadata.yes"
								type="number"
							></it-input>
						</td>
						<td>
							<it-input
								[(ngModel)]="document.versions[0].metadata.no"
								type="number"
							></it-input>
						</td>
						<td>
							<it-input
								[(ngModel)]="document.versions[0].metadata.abs"
								type="number"
							></it-input>
						</td>
						<td>
							<it-input
								[(ngModel)]="
									document.versions[0].metadata.voteNotes
								"
								type="text"
							></it-input>
						</td>
					</tr>
				}
			}
		</ng-container>
	</it-table>
}
<it-modal #createAmendment>
	<ng-container modalTitle>{{
		"iterlex.create-amendment" | translate
	}}</ng-container>
	<form
		#newAmendmentForm="ngForm"
		(ngSubmit)="onCreateAmendmentSubmit(newAmendmentForm)"
	>
		<it-input
			type="text"
			name="title"
			ngModel
			required
			[label]="'iterlex.title' | translate"
		></it-input>
		<it-input
			type="text"
			name="article"
			ngModel
			required
			[label]="'iterlex.article' | translate"
		></it-input>
		<it-select
			name="language"
			[label]="'iterlex.language' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "it.utils.select-language" | translate }}
			</option>
			@for (language of languages; track language) {
				<option [value]="language">
					{{ "iterlex." + language | translate }}
				</option>
			}
		</it-select>
		<it-input
			type="date"
			name="date"
			ngModel
			required
			[label]="'iterlex.date' | translate"
		></it-input>
		<it-input
			type="time"
			name="time"
			ngModel
			required
			[label]="'iterlex.time' | translate"
			ngModel="00:00"
		></it-input>
		<it-select
			name="amendmentType"
			[label]="'iterlex.amendment-type' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "iterlex.select-amendment-type" | translate }}
			</option>
			@for (amendmentType of amendmentTypes; track amendmentType) {
				<option selected [value]="amendmentType">
					{{ "iterlex.amendment-" + amendmentType | translate }}
				</option>
			}
		</it-select>
		<it-input
			#proponentInput
			type="text"
			name="proponent"
			ngModel
			[label]="'iterlex.proponents' | translate"
		>
			<button
				size="xs"
				itButton="outline-primary"
				[disabled]="!newAmendmentForm.value.proponent"
				(click)="
					proponents.push(newAmendmentForm.value.proponent);
					proponentInput.writeValue('')
				"
				append
			>
				<it-icon name="plus"></it-icon>
			</button>
		</it-input>
		<ul>
			@for (proponent of proponents; track proponent) {
				<li>
					{{ proponent }}
					<button
						size="xs"
						itButton="outline-danger"
						(click)="proponents.splice($index, 1)"
						append
					>
						<it-icon
							name="delete"
							color="danger"
							[title]="'it.core.remove' | translate"
						></it-icon>
					</button>
				</li>
			}
		</ul>
		<button
			itButton="primary"
			type="submit"
			size="xs"
			[disabled]="!newAmendmentForm.valid || proponents.length === 0"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.create-amendment" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #editDocumentModal>
	<ng-container modalTitle>{{ "it.general.edit" | translate }}</ng-container>
	<form
		#editDocumentForm="ngForm"
		(ngSubmit)="onEditDocumentSubmit(editDocumentForm)"
	>
		@if (currentDocument) {
			<it-input
				type="text"
				name="title"
				ngModel
				required
				[label]="'iterlex.title' | translate"
				[ngModel]="currentDocument.title"
			></it-input>
			<button
				itButton="primary"
				type="submit"
				[disabled]="!editDocumentForm.valid"
				data-bs-dismiss="modal"
			>
				{{ "it.general.save" | translate }}
			</button>
		}
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #createVersionModal>
	<ng-container modalTitle>
		@if (!createSubamenment) {
			{{ "iterlex.create-version" | translate }}
		} @else {
			{{ "iterlex.create-subamendment" | translate }}
		}
	</ng-container>
	<form
		#newVersionForm="ngForm"
		(ngSubmit)="onCreateVersionSubmit(newVersionForm)"
	>
		<it-input
			type="date"
			name="date"
			ngModel
			required
			[label]="'iterlex.date' | translate"
		></it-input>
		<it-input
			type="time"
			name="time"
			ngModel
			required
			[label]="'iterlex.time' | translate"
			ngModel="00:00"
		></it-input>
		<it-select
			name="language"
			[label]="'iterlex.language' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "it.utils.select-language" | translate }}
			</option>
			@for (language of languages; track language) {
				<option [value]="language">
					{{ "iterlex." + language | translate }}
				</option>
			}
		</it-select>
		<it-input
			type="text"
			name="article"
			[ngModel]="currentVersion?.metadata?.article"
			required
			[label]="'iterlex.article' | translate"
		></it-input>
		<it-select
			name="amendmentType"
			[label]="'iterlex.amendment-type' | translate"
			[ngModel]="currentVersion?.metadata?.amendmentType ?? ''"
			required
		>
			<option selected value="">
				{{ "iterlex.select-amendment-type" | translate }}
			</option>
			@for (amendmentType of amendmentTypes; track amendmentType) {
				<option selected [value]="amendmentType">
					{{ "iterlex.amendment-" + amendmentType | translate }}
				</option>
			}
		</it-select>
		<it-input
			#proponentInput
			type="text"
			name="proponent"
			ngModel
			[label]="'iterlex.proponents' | translate"
		>
			<button
				size="xs"
				itButton="outline-primary"
				[disabled]="!newVersionForm.value.proponent"
				(click)="
					proponents.push(newVersionForm.value.proponent);
					proponentInput.writeValue('')
				"
				append
			>
				<it-icon name="plus"></it-icon>
			</button>
		</it-input>
		<ul>
			@for (proponent of proponents; track proponent) {
				<li>
					{{ proponent }}
					<button
						size="xs"
						itButton="outline-danger"
						(click)="proponents.splice($index, 1)"
						append
					>
						<it-icon
							name="delete"
							color="danger"
							[title]="'it.core.remove' | translate"
						></it-icon>
					</button>
				</li>
			}
		</ul>
		<button
			itButton="primary"
			type="submit"
			size="xs"
			[disabled]="!newVersionForm.valid || proponents.length === 0"
			data-bs-dismiss="modal"
		>
			@if (!createSubamenment) {
				{{ "iterlex.create-version" | translate }}
			} @else {
				{{ "iterlex.create-subamendment" | translate }}
			}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #createAttachmentModal>
	<ng-container modalTitle>{{
		"iterlex.create-attachment" | translate
	}}</ng-container>
	<form
		#createAttachmentForm="ngForm"
		(ngSubmit)="onCreateAttachmentSubmit(createAttachmentForm)"
	>
		<it-select
			name="documentSubtype"
			[label]="'iterlex.document-subtype' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "iterlex.select-document-subtype" | translate }}
			</option>
			@for (
				documentSubtype of documentSubtypes;
				track documentSubtype.id
			) {
				<option
					[value]="
						documentSubtype.documentType + '/' + documentSubtype.id
					"
				>
					{{
						documentSubtype.label[
							"iterlex.currentLanguage" | translate
						]
					}}
				</option>
			}
		</it-select>
		<it-input
			type="text"
			name="title"
			ngModel
			required
			[label]="'iterlex.title' | translate"
		></it-input>
		<it-input
			type="text"
			name="number"
			ngModel
			required
			[label]="'iterlex.number' | translate"
		></it-input>
		<it-select
			name="language"
			[label]="'iterlex.language' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "it.utils.select-language" | translate }}
			</option>
			@for (language of languages; track language) {
				<option [value]="language">
					{{ "iterlex." + language | translate }}
				</option>
			}
		</it-select>
		<it-input
			type="date"
			name="date"
			ngModel
			required
			[label]="'iterlex.date' | translate"
		></it-input>
		<it-input
			type="time"
			name="time"
			ngModel
			required
			[label]="'iterlex.time' | translate"
			ngModel="00:00"
		></it-input>
		<button
			itButton="primary"
			type="submit"
			[disabled]="!createAttachmentForm.valid"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.create-attachment" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #editMetadataModal>
	<ng-container modalTitle>{{
		"iterlex.edit-amendment" | translate
	}}</ng-container>
	<form
		#editMetadataForm="ngForm"
		(ngSubmit)="onEditVersionSubmit(editMetadataForm)"
	>
		@if (currentVersion) {
			<it-input
				type="text"
				name="article"
				ngModel
				required
				[ngModel]="currentVersion.metadata.article"
				[label]="'iterlex.article' | translate"
			></it-input>
			<it-select
				name="amendmentType"
				[ngModel]="currentVersion.metadata.amendmentType ?? ''"
				[label]="'iterlex.amendment-type' | translate"
				ngModel
				required
			>
				<option selected value="">
					{{ "iterlex.select-amendment-type" | translate }}
				</option>
				@for (amendmentType of amendmentTypes; track amendmentType) {
					<option selected [value]="amendmentType">
						{{ "iterlex.amendment-" + amendmentType | translate }}
					</option>
				}
			</it-select>
			<it-input
				#proponentInput
				type="text"
				name="proponent"
				ngModel
				[label]="'iterlex.proponents' | translate"
			>
				<button
					size="xs"
					itButton="outline-primary"
					[disabled]="!editMetadataForm.value.proponent"
					(click)="
						proponents.push(editMetadataForm.value.proponent);
						proponentInput.writeValue('')
					"
					append
				>
					<it-icon name="plus"></it-icon>
				</button>
			</it-input>
			<ul>
				@for (proponent of proponents; track proponent) {
					<li>
						{{ proponent }}
						<button
							size="xs"
							itButton="link"
							(click)="proponents.splice($index, 1)"
							append
						>
							<it-icon
								name="delete"
								color="danger"
								[title]="'it.core.remove' | translate"
							></it-icon>
						</button>
					</li>
				}
			</ul>
			<button
				itButton="primary"
				size="xs"
				type="submit"
				[disabled]="!editMetadataForm.valid || proponents.length === 0"
				data-bs-dismiss="modal"
			>
				{{ "it.general.save" | translate }}
			</button>
		}
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #moveVersionModal>
	<ng-container modalTitle>{{
		"iterlex.select-steps" | translate
	}}</ng-container>
	<form
		#moveVersionForm="ngForm"
		(ngSubmit)="onMoveVersionSubmit(moveVersionForm)"
	>
		@if (phases.length === 0) {
			<p>{{ "it.core.loading" | translate }}</p>
		} @else {
			<div class="form-group">
				@for (phase of phases; track phase.id) {
					<it-accordion
						[title]="
							phase.label['iterlex.currentLanguage' | translate]
						"
					>
						@if (!steps[phase.id]) {
							<p>{{ "it.core.loading" | translate }}</p>
						}
						@for (step of steps[phase.id]; track step.id) {
							<it-checkbox
								[checked]="currentSteps.includes(step.id)"
								[disabled]="this.step.id === step.id"
								[label]="
									step.label[
										'iterlex.currentLanguage' | translate
									]
								"
								(click)="changeStep(phase.id, step.id)"
							></it-checkbox>
						}
					</it-accordion>
				}
			</div>
			<button itButton="primary" type="submit" data-bs-dismiss="modal">
				{{ "it.general.save" | translate }}
			</button>
		}
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #deleteVersionModal closeButton="false" popconfirm="true">
	<ng-container modalTitle>{{
		"iterlex.delete-version-confirm" | translate
	}}</ng-container>
	@if (currentVersion) {
		<p>{{ currentVersion.title }}</p>
	}
	<ng-container footer>
		@if (currentVersion) {
			<button
				itButton="danger"
				type="button"
				data-bs-dismiss="modal"
				(click)="deleteVersion(currentVersion.expressionUri)"
			>
				{{ "it.core.remove" | translate }}
			</button>
		}
		<button
			itButton="outline-secondary"
			type="button"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.cancel" | translate }}
		</button>
	</ng-container>
</it-modal>
<it-modal #deleteDocumentModal closeButton="false" popconfirm="true">
	<ng-container modalTitle>{{
		"iterlex.delete-document-confirm" | translate
	}}</ng-container>
	@if (currentDocument) {
		<p>{{ currentDocument.title }}</p>
	}
	<ng-container footer>
		@if (currentDocument) {
			<button
				itButton="danger"
				type="button"
				data-bs-dismiss="modal"
				(click)="deleteDocument(currentDocument.workUri)"
			>
				{{ "it.core.remove" | translate }}
			</button>
		}
		<button
			itButton="outline-secondary"
			type="button"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.cancel" | translate }}
		</button>
	</ng-container>
</it-modal>
